import React from 'react';

const EmptyState = ({ 
  title, 
  description, 
  action, 
  actionLabel,
  actionIcon,
  secondaryAction, 
  secondaryLabel,
  className = '' 
}) => {
  return (
    <div className={`text-center py-12 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 ${className}`}>
      {title && (
        <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
          {title}
        </h2>
      )}
      {description && (
        <div className={`text-gray-600 dark:text-gray-400 ${action || secondaryAction ? 'mb-4' : ''}`}>
          {description}
        </div>
      )}
      {(action || secondaryAction) && (
        <div className="flex justify-center gap-3">
          {action && actionLabel && (
            <button
              onClick={action}
              className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
            >
              {actionIcon}
              {actionLabel}
            </button>
          )}
          {secondaryAction && secondaryLabel && (
            <button
              onClick={secondaryAction}
              className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 hover:underline text-sm"
            >
              {secondaryLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
